import React from "react";
import { IoChatboxOutline } from "react-icons/io5";
import { VscSettingsGear } from "react-icons/vsc";
import { useLanguage } from "../Translations/LenguageContext";

const ChatHeader = ({ chatTitle, toggleSidebar, sidebarOpen }) => {
    const {t} = useLanguage()
    return (
        <div className="chat_header">
            {chatTitle ? (
                <p className="chat_title fade-in"><i><IoChatboxOutline /></i>{chatTitle}</p>
            ) : (
                <p className="chat_title"><i><IoChatboxOutline /></i>{t.sidebar.playground}</p>
            )}
            <div className="chat_header_btn_cont">
            {/* <button className="main_mcp_cont_chat_btn fade-in">
                <BsThreeDotsVertical/>
            </button> */}
            {!sidebarOpen && (
                <button className="main_mcp_cont_chat_btn fade-in" onClick={toggleSidebar}>
                <VscSettingsGear />
            </button>
            )}
            </div>
        </div>
    )
}

export default ChatHeader